import { render, staticRenderFns } from "./MultiLangCouponMaintain.vue?vue&type=template&id=35a0cdf7&scoped=true"
import script from "./MultiLangCouponMaintain.vue?vue&type=script&lang=js"
export * from "./MultiLangCouponMaintain.vue?vue&type=script&lang=js"
import style0 from "./MultiLangCouponMaintain.vue?vue&type=style&index=0&id=35a0cdf7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0cdf7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/muying-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35a0cdf7')) {
      api.createRecord('35a0cdf7', component.options)
    } else {
      api.reload('35a0cdf7', component.options)
    }
    module.hot.accept("./MultiLangCouponMaintain.vue?vue&type=template&id=35a0cdf7&scoped=true", function () {
      api.rerender('35a0cdf7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/i18n/MultiLangCouponMaintain.vue"
export default component.exports